module.exports = __webpack_public_path__ + "static/media/Gantt.07fda834.png";